import * as yup from 'yup';

export const PDFAxisValiadations = yup.object({
  year: yup
    .string()
    .required("Year is required")
});
